/**
 * The SVG `font-family` for the FDA Nutrition Facts panel — a PLAIN string constant,
 * deliberately in its own module with **zero imports**.
 *
 * Why split out from `fonts.ts`: `fonts.ts` imports `node:url` (for the bundled-TTF
 * path helpers used by the server-side resvg export). The SVG builder (`svg-us-nf.ts`)
 * needs only this family name, and it runs in the BROWSER (the admin live preview).
 * Keeping the name here lets the browser bundle import it without pulling `node:url`
 * (a node-only import in the client bundle fails the Vite build).
 *
 * Liberation Sans is metric-compatible with Helvetica (the FDA-spec metric face) and
 * SIL-OFL licensed. In the browser the metric-compatible system sans (Arial/Helvetica)
 * fallback is acceptable for M1 (near-identical layout).
 */
export const FONT_FAMILY = "Liberation Sans" as const;

/**
 * The CSS `font-family` STACK emitted on every `<text>` element. The bundled family comes first,
 * then metric-compatible system faces (Arial/Helvetica), then the `sans-serif` generic — so a
 * consumer that lacks "Liberation Sans" degrades to a sans face instead of the UA default (often
 * a serif) or `.notdef` tofu. This matters in the BROWSER live preview (which does not @font-face
 * the bundled TTF, per LabelPreview.tsx). The Node export still binds "Liberation Sans" from
 * resvg `fontFiles` (loadSystemFonts:false), so the PNG stays byte-deterministic — the fallbacks
 * only ever take effect where the bundled face is genuinely unavailable.
 */
export const FONT_STACK = "Liberation Sans, Arial, Helvetica, sans-serif" as const;
